import React, { useEffect, useState, useContext } from "react";
import {
  getAllInvoiceDetails,
  getQBCustomerId,
  getQBServiceId,
  approveAllPendingInvoices,
  archiveAllInvoices,
} from "../../webServices/Apis";
import { message, Tooltip, Pagination } from "antd";
import Loader from "../Loader/Loader";
import {
  AiFillEdit,
  AiOutlineEye,
  AiFillPrinter,
  AiOutlineDown,
  AiOutlineUp,
} from "react-icons/ai";
import ViewInvoiceDetails from "./ViewInvoiceDetails";
import EditInvoice from "./EditInvoice";
import { useNavigate } from "react-router";
import { UserContext } from "../../App";

export const Invoice = () => {
  const { setIsAuthenticated } = useContext(UserContext);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [activeInvoices, setActiveInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewInvoice, setInvoice] = useState(false);
  const [editInvoice, setEditInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState("");
  const [isUpdated, setIsUpdated] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [customerId, setCustomerId] = useState("");
  const [serviceId, setServiceId] = useState("");
  const [itemsPerPage] = useState(10);

  const [expanded, setExpanded] = useState({});

  const navigation = useNavigate();
  // const navigate = useNavigate();

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInvoice = activeInvoices.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleGetAllInvoices = async () => {
    try {
      setLoading(true);
      const res = await getAllInvoiceDetails();
      console.log("response............", res?.data?.data);
      if (res?.data?.success) {
        const activeInvoices = res?.data?.data
          .map((subContractor) => {
            const activeInvoices = subContractor?.invoices.filter(
              (invoice) => !invoice?.projectInvoice?.invoiceAccepted
            );

            if (activeInvoices.length > 0) {
              return {
                ...subContractor,
                invoices: activeInvoices,
              };
            } else {
              return null;
            }
          })
          .filter(Boolean); // Remove nulls;
        const reverseInvoices = [...activeInvoices].reverse();
        setActiveInvoices(reverseInvoices);
        setInvoiceDetails(res?.data?.data || []);
      }
    } catch (error) {
      console.log("Error while fetching the invoice", error.message);
      if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.removeItem("token");
        setIsAuthenticated(false);
        window.location.href = "/login";
      }

      if (error?.response?.status === 500) {
        message.error("Server not responding");
        return;
      }
      if (error?.response?.status === 403) {
        window.alert("Your subcription has been expired");
        localStorage.clear();
        setIsAuthenticated(false);
        window.location.href = "/login";
      } else {
        return;
      }
    } finally {
      setLoading(false);
    }
  };

  const handleArchivedInvoices = () => {
    navigation("/archived-invoices", { state: { invoiceDetails } });
  };

  const handlePrintInvoice = (invoice) => {
    navigation("/print-invoice", { state: { invoice } });
  };

  useEffect(() => {
    handleGetAllInvoices();
  }, []);

  const handleView = (invoice) => {
    setInvoice(true);
    setInvoiceData(invoice);
  };

  const handleEdit = async (invoice) => {
    setLoading(true);
    try {
      const customerEmail = invoice.subContractorEmail;
      const taskName = invoice.projectInvoice.qbServiceName;
      if (localStorage.getItem("access_token")) {
        const getCusId = await getQBCustomerId(customerEmail);

        if (getCusId?.status === 200) {
          // Extract the Customer ID using a regex
          const customerIdMatch = getCusId.data.match(/Customer ID: (\d+)/);

          if (customerIdMatch) {
            // Set the customerId to the extracted value
            const id = customerIdMatch[1]; // This will give you the numeric value of the Customer ID
            setCustomerId(id);
          } else {
            console.error("Customer ID not found in the Quickbooks data");
            message.error("Customer ID not found in the Quickbooks data");
          }
        }

        const getServiceId = await getQBServiceId(taskName);
        if (getServiceId.status === 401) {
          message.error("Session Timeout !");
          localStorage.clear();
          window.location.href = "/login";
          return;
        }
        if (getServiceId?.status === 200) {
          // Extract the Customer ID using a regex
          const serviceIdMatch = getServiceId.data.match(
            /Service Item ID: (\d+)/
          );

          if (serviceIdMatch) {
            // Set the serviceId to the extracted value
            const id = serviceIdMatch[1]; // This will give you the numeric value of the Customer ID
            setServiceId(id);
          } else {
            console.error("Service ID not found in the Quickbooks data");
            message.error("Service ID not found in the Quickbooks data");
          }
        }
      }
    } catch (error) {
      console.log("Error in QB ", error.message);
      if (error?.response?.status === 401) {
        message.error("Session Timeout !");
        localStorage.clear();
        window.location.href = "/login";
        return;
      }
    } finally {
      setLoading(false);
    }

    setEditInvoice(true);
    setInvoiceData(invoice);
  };

  const handleClose = () => {
    setInvoice(false);
  };

  useEffect(() => {
    if (isUpdated) {
      handleGetAllInvoices();

      setIsUpdated(false);
    }
  }, [isUpdated]);

  function formatDate(dateString) {
    const date = new Date(dateString); // Parse the date string
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed, so add 1)
    const day = String(date.getDate()).padStart(2, "0"); // Get day
    const year = date.getFullYear(); // Get year

    return `${month}-${day}-${year}`; // Return formatted date as mm/dd/yyyy
  }

  const toggleExpand = (subContractorId) => {
    setExpanded((prev) => ({
      ...prev,
      [subContractorId]: !prev[subContractorId],
    }));
  };

  const handleApprove = async (group) => {
    try {
      setLoading(true);

      const invoiceIds = group?.invoices
        ?.filter(
          (invoice) =>
            !invoice?.projectInvoice?.paidStatus &&
            !invoice?.projectInvoice?.invoiceAccepted
        )
        .map((invoice) => invoice?.projectInvoice?.id);

      if (invoiceIds.length === 0) {
        message.error("No eligible invoices to approve.");
        return;
      }

      const payload = {
        invoiceIds,
        paidStatus: true,
      };

      const response = await approveAllPendingInvoices(payload);
      if (response?.data?.success) {
        message.success(response?.data?.message);
        handleGetAllInvoices();
      }
    } catch (error) {
      console.log("Error while approve all invoices", error);
      if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.removeItem("token");
        setIsAuthenticated(false);
        window.location.href = "/login";
      }

      if (error?.response?.status === 500) {
        message.error("Server not responding");
        return;
      }
      if (error?.response?.status === 403) {
        window.alert("Your subcription has been expired");
        localStorage.clear();
        setIsAuthenticated(false);
        window.location.href = "/login";
      } else {
        return;
      }
    } finally {
      setLoading(false);
    }
  };

  const handleArchive = async (group) => {
    try {
      setLoading(true);

      const invoiceIds = group?.invoices
        ?.filter(
          (invoice) =>
            !invoice?.projectInvoice?.invoiceAccepted
        )
        .map((invoice) => invoice?.projectInvoice?.id);

      if (invoiceIds.length === 0) {
        message.error("No active invoice to archive");
        return;
      }

      const payload = {
        invoiceIds,
        invoiceAccepted: true,
      };


      const response = await archiveAllInvoices(payload);
      if (response?.data?.success) {
        message.success(response?.data?.message);
        handleGetAllInvoices();
      }
    } catch (error) {
      console.log("Error while approve all invoices", error);
      if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.removeItem("token");
        setIsAuthenticated(false);
        window.location.href = "/login";
      }

      if (error?.response?.status === 500) {
        message.error("Server not responding");
        return;
      }
      if (error?.response?.status === 403) {
        window.alert("Your subcription has been expired");
        localStorage.clear();
        setIsAuthenticated(false);
        window.location.href = "/login";
      } else {
        return;
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePrintAllApproved = async (group) => {
    const allApprovedInvoices = group?.invoices
        ?.filter(
          (invoice) =>
            invoice?.projectInvoice?.paidStatus &&
            !invoice?.projectInvoice?.invoiceAccepted
        )

        if(allApprovedInvoices.length === 0){
          message.error("No approved and active invoice found to print")
          return;
        }

        navigation("/print-all-invoice", { state: { allApprovedInvoices } });

  }

  return (
    <>
      {loading && <Loader />}

      <div className="p-4">
        <div className="flex flex-row justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">Active Invoices</h2>
          {/* <Tooltip title="Click to view archived invoices">
            <button className='bg-orange-200 hover:bg-green-400 font-bold py-2 px-12 rounded border-2 border-green-500 shadow-md shadow-yellow-300'
              onClick={handleQuickbookRedirect}
            >
              Connect to Quickbooks
            </button>
          </Tooltip> */}
          <Tooltip title="Click to view archived invoices">
            <button
              className="bg-blue-200 hover:bg-blue-400 font-bold py-2 px-12 rounded border border-gray-900 shadow-md shadow-green-300"
              onClick={handleArchivedInvoices}
            >
              Archived Invoices
            </button>
          </Tooltip>
        </div>

        <div className="mt-6">
          {currentInvoice?.length > 0 ? (
            currentInvoice.map((group) => (
              <div
                key={group?.subContractorId}
                className="mb-6 border border-gray-300 rounded"
              >
                {/* Header with toggle */}
                <div
                  className="flex justify-between items-center bg-gray-800 text-white px-4 py-3 cursor-pointer"
                  onClick={() => toggleExpand(group?.subContractorId)}
                >
                  <h2 className="font-semibold text-lg">
                    Subcontractor : {group?.subContractorName}
                  </h2>
                  <span className="text-xl">
                    {expanded[group?.subContractorId] ? (
                      <AiOutlineUp />
                    ) : (
                      <AiOutlineDown />
                    )}
                  </span>
                </div>

                {/* Table - visible only if expanded */}
                {expanded[group?.subContractorId] && (
                  <div className="border border-gray-800 border-t-0 rounded-b">
                    <table className="min-w-full bg-white">
                      <thead className="bg-gray-800 text-white">
                        <tr>
                          <th className="py-3 px-4 text-center text-sm">#ID</th>
                          <th className="py-3 px-4 text-center text-sm">
                            Submitted Date
                          </th>
                          <th className="py-3 px-4 text-center text-sm">
                            Assigned Project Name
                          </th>
                          <th className="py-3 px-4 text-center text-sm">
                            Invoice Status
                          </th>
                          <th className="py-3 px-4 text-center text-sm">
                            Paid Status
                          </th>
                          <th className="py-3 px-4 text-center text-sm">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {group?.invoices?.map((invoice, index) => (
                          <tr
                            key={invoice?.projectInvoice?.id || index}
                            className={`text-center transition ${
                              index % 2 === 0 ? "bg-white" : "bg-gray-300"
                            }`}
                          >
                            <td className="py-2 px-4 border-b">
                              {invoice?.projectInvoice?.id}
                            </td>
                            <td className="py-2 px-4 border-b">
                              {invoice?.projectInvoice?.startDate
                                ? formatDate(invoice?.projectInvoice?.startDate)
                                : "N/A"}
                            </td>
                            <td className="py-2 px-4 border-b">
                              {invoice?.projectInvoice?.assignProjectName}
                            </td>
                            <td className="py-2 px-4 border-b">
                              {invoice?.projectInvoice?.invoiceAccepted
                                ? "Archived"
                                : "Active"}
                            </td>
                            <td
                              className={`py-2 px-4 border-b ${
                                invoice?.projectInvoice?.paidStatus
                                  ? "text-green-500"
                                  : "text-yellow-500"
                              }`}
                            >
                              {invoice?.projectInvoice?.paidStatus
                                ? "Approved"
                                : "Pending"}
                            </td>
                            <td className="py-2 px-4 border-b justify-center w-1/6">
                              <div className="flex gap-2 justify-center items-center">
                                <Tooltip title="View Invoice">
                                  <button
                                    onClick={() => handleView(invoice)}
                                    className="text-blue-500 hover:text-blue-700"
                                  >
                                    <AiOutlineEye className="text-xl" />
                                  </button>
                                </Tooltip>
                                <Tooltip title="Edit Invoice">
                                  <button
                                    onClick={() => handleEdit(invoice)}
                                    className="text-blue-500 hover:text-blue-700"
                                  >
                                    <AiFillEdit className="text-xl" />
                                  </button>
                                </Tooltip>
                                <Tooltip title="Print Invoice">
                                  <button
                                    onClick={() => handlePrintInvoice(invoice)}
                                    className="text-blue-500 hover:text-blue-700"
                                  >
                                    <AiFillPrinter className="text-xl" />
                                  </button>
                                </Tooltip>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* ✅ Buttons below the table */}
                    <div className="flex justify-end gap-3 p-4 bg-gray-50 border-t">
                      <button
                        className="bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded"
                        onClick={() => handleApprove(group)}
                      >
                        Approve All
                      </button>
                      <button
                        className="bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded"
                        onClick={() => handleArchive(group)}
                      >
                        Archive All
                      </button>
                      <button
                        className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded"
                        onClick={() => handlePrintAllApproved(group)}
                      >
                        Print Invoices
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className="text-center py-4">No active invoice found</p>
          )}
        </div>

        <div className="mt-4 flex justify-end">
          <Pagination
            current={currentPage}
            total={activeInvoices?.length}
            pageSize={itemsPerPage}
            onChange={handlePageChange}
          />
        </div>
      </div>

      {viewInvoice && (
        <ViewInvoiceDetails invoiceDetails={invoiceData} close={handleClose} />
      )}

      {editInvoice && (
        <EditInvoice
          invoiceDetails={invoiceData}
          qbCustomerId={customerId}
          qbServiceId={serviceId}
          setIsUpdated={setIsUpdated} // pass setIsUpdated directly
          close={() => {
            setEditInvoice(false);
          }}
          onClick={() => {
            handleGetAllInvoices();
          }}
        />
      )}
    </>
  );
};

export default Invoice;
